import { EventBus } from '@/calendesk/plugins/eventBus'
import store from '@/store'
import { errorNotification } from '@/calendesk/prototypes/notifications'

export function handle2FAVerification (sessionData: any): Promise<any> {
  return new Promise((resolve, reject) => {
    const handle2FACode = (twoFACode: string, errorCallback: Function, successCallback: Function) => {
      store
        .dispatch('user/login2fa', {
          session_id: sessionData.session_id,
          code: twoFACode
        })
        .then((result) => {
          successCallback()
          resolve(result)
        })
        .catch((error) => {
          // Check if the session expired or session_id is invalid
          if (
            error?.response?.data?.code === 'TWO_FACTOR_SESSION_EXPIRED' ||
            error?.response?.data?.errors?.session_id
          ) {
            // Show the session expired error message
            errorNotification('2fa_session_expired_error', error, false)
            // Close dialog via EventBus and then reject with cancellation error
            EventBus.$emit('2FA_CLOSE_DIALOG')
            reject(new Error('2FA_VERIFICATION_CANCELLED'))
            return
          }

          // Regular incorrect code error - show error and keep the dialog open
          errorNotification('2fa_verify_incorrect_error', error, false)
          errorCallback(error)
        })
    }

    EventBus.$emit(
      '2FA_EXTRA_VERIFICATION',
      handle2FACode,
      reject,
      sessionData
    )
  })
}
